import { types, Instance, SnapshotOut } from "mobx-state-tree";
import api from "services/api/api";

const Coordinates = types.model("coordinates").props({
  coordinates: types.array(types.number),
});

const AlarmsModel = types.model("Alarms").props({
  address: types.maybeNull(types.string),
  group: types.maybeNull(types.string),
  serial: types.maybeNull(types.string),
  id: types.maybeNull(types.string),
  connected: types.maybeNull(types.boolean),
  energy: types.maybeNull(types.boolean),
  connectedDate: types.maybeNull(types.string),
  location: types.maybeNull(Coordinates),
  Tension_Referidas_Neutro_L1: types.maybeNull(types.number),
  Tension_Referidas_Neutro_L2: types.maybeNull(types.number),
  Tension_Referidas_Neutro_L3: types.maybeNull(types.number),
  Tension_Promedio_Trifasica_L1L2L3: types.maybeNull(types.number),
  Zero_Sequence_Voltage: types.maybeNull(types.number),
  Line_Voltage_Avg: types.maybeNull(types.number),
  Frecuencia: types.maybeNull(types.number),
  Contador_Fallas: types.maybeNull(types.number),

  Corriente_Fase_L1: types.maybeNull(types.number),
  Corriente_Fase_L2: types.maybeNull(types.number),
  Corriente_Fase_L3: types.maybeNull(types.number),
  Corriente_Neutro: types.maybeNull(types.number),
  Promedio_Corriente_Total: types.maybeNull(types.number),

  Potencia_Activa_Fase_L1: types.maybeNull(types.number),
  Potencia_Activa_Fase_L2: types.maybeNull(types.number),
  Potencia_Activa_Fase_L3: types.maybeNull(types.number),
  Potencia_Activa_Total: types.maybeNull(types.number),

  Potencia_Aparente_Fase_L1: types.maybeNull(types.number),
  Potencia_Aparente_Fase_L2: types.maybeNull(types.number),
  Potencia_Aparente_Fase_L3: types.maybeNull(types.number),
  Potencia_Aparente_Total: types.maybeNull(types.number),

  Potencia_Reactiva_Fase_L1: types.maybeNull(types.number),
  Potencia_Reactiva_Fase_L2: types.maybeNull(types.number),
  Potencia_Reactiva_Fase_L3: types.maybeNull(types.number),
  Potencia_Reactiva_Total: types.maybeNull(types.number),

  Factor_Potencia_L1: types.maybeNull(types.number),
  Factor_Potencia_L2: types.maybeNull(types.number),
  Factor_Potencia_L3: types.maybeNull(types.number),
  Factor_Potencia_Total: types.maybeNull(types.number),

  Harmonicos_Voltage_L1: types.maybeNull(types.number),
  Harmonicos_Voltage_L: types.maybeNull(types.number),
  Harmonicos_Voltage_L3: types.maybeNull(types.number),
  Harmonicos_Corriente_L1: types.maybeNull(types.number),
  Harmonicos_Corriente_L2: types.maybeNull(types.number),
  Harmonicos_Corriente_L3: types.maybeNull(types.number),

  Fase_L1_Positive_Active_Energy: types.maybeNull(types.number),
  Fase_L2_Positive_Active_Energy: types.maybeNull(types.number),
  Fase_L3_Positive_Active_Energy: types.maybeNull(types.number),
  Total_Positive_Active_Energy: types.maybeNull(types.number),

  Fase_L1_Reverse_Active_Energy: types.maybeNull(types.number),
  Fase_L2_Reverse_Active_Energy: types.maybeNull(types.number),
  Fase_L3_Reverse_Active_Energy: types.maybeNull(types.number),
  Total_Reverse_Active_Energy: types.maybeNull(types.number),

  Fase_L1_Positive_Reactive_Energy: types.maybeNull(types.number),
  Fase_L2_Positive_Reactive_Energy: types.maybeNull(types.number),
  Fase_L3_Positive_Reactive_Energy: types.maybeNull(types.number),
  Total_Positive_Reactive_Energy: types.maybeNull(types.number),

  Fase_L1_Reverse_Reactive_Energy: types.maybeNull(types.number),
  Fase_L2_Reverse_Reactive_Energy: types.maybeNull(types.number),
  Fase_L3_Reverse_Reactive_Energy: types.maybeNull(types.number),
  Total_Reverse_Reactive_Energy: types.maybeNull(types.number),

  Fase_L1_Aparent_Energy: types.maybeNull(types.number),
  Fase_L2_Aparent_Energy: types.maybeNull(types.number),
  Fase_L3_Aparent_Energy: types.maybeNull(types.number),
  Total_Aparent_Energy: types.maybeNull(types.number),

  Temperatura_Interna: types.maybeNull(types.number),
  Temperatura_Medida: types.maybeNull(types.number),

});

const Location = types.model("Location").props({
  lat: types.number,
  lng: types.number,
});

export const EnergyEfficiencyModelAlarm = types
  .model("EnergyEfficiency")
  .props({
    alarms: types.optional(types.array(AlarmsModel), []),
    locationSelected: types.maybeNull(Location),
    idSelected: types.maybeNull(types.string),
    isLoading: types.boolean,
    idLoading: types.maybeNull(types.string),
    center: Location,
  })
  .views((self) => ({
    filterValues(value: string | null) {
      if (value === null) return self.alarms;
      return self.alarms.filter(
        (alarm) =>
          alarm.id?.toLowerCase().includes(value.toLowerCase()) ||
          alarm.address?.toLowerCase().includes(value.toLowerCase())
      );
    },
  }))
  .actions((self) => {
    function setAlarms(alarms: any) {
      self.alarms = alarms;
    }
    function setlocationSelected(cordinates: any) {
      self.locationSelected = cordinates;
    }
    function setId(id: any) {
      self.idSelected = self.idSelected === id ? null : id;
    }
    function setIsLoading(isLoading: boolean, id: string | null) {
      self.idLoading = id;
      self.isLoading = isLoading;
    }
    function setLoading(loading: any) {
      self.isLoading = loading;
    }
    function setCenter(coordinates: any) {
      self.center = coordinates;
    }
    return {
      setAlarms,
      setlocationSelected,
      setCenter,
      setIsLoading,
      setLoading,
      setId,
    };
  })
  .actions((self) => ({
    getDevices: async () => {
      try {
        self.setLoading(true);
        const alarmsApi = api.energy_efficiency;
        const response = await alarmsApi.getDevice();
        self.setAlarms(response?.devices);
        self.setCenter(response?.center);
        self.setLoading(false);
        self.setIsLoading(false, null);
      } catch (error) {
        console.log(error);
      }
    },
  }));

type EnergyEfficiencyModelType = Instance<typeof EnergyEfficiencyModelAlarm>;
export type EnergyEfficiency = EnergyEfficiencyModelType;
type EnergyEfficiencySnapshotType = SnapshotOut<typeof EnergyEfficiencyModelAlarm>;
export type EnergyEfficiencySnapshot = EnergyEfficiencySnapshotType;
export const energy_efficiencyDefaultModel = () =>
  types.optional(EnergyEfficiencyModelAlarm, {
    alarms: [],
    locationSelected: null,
    idSelected: null,
    isLoading: false,
    idLoading: null,
    center: { lat: 0, lng: 0 },
  });